var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreciselyEngineered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4977 0C12.3111 0 0 12.3122 0 27.5C0 42.6878 12.3111 55 27.4977 55C39.8375 55 50.2788 46.8711 53.7597 35.6757L46.7483 37.3187C43.1727 44.3162 35.8945 49.1069 27.4975 49.1069C15.5652 49.1069 5.89221 39.433 5.89221 27.4997C5.89221 15.5664 15.5652 5.89258 27.4975 5.89258C34.2672 5.89258 40.3096 9.00631 44.271 13.8798L50.3529 12.2043C45.4184 4.84443 37.0237 0 27.4977 0ZM27.4975 42.7952C19.0508 42.7952 12.2033 35.9472 12.2033 27.4997C12.2033 19.0522 19.0508 12.2042 27.4975 12.2042C35.9443 12.2042 42.7918 19.0522 42.7918 27.4997C42.7918 35.9472 35.9443 42.7952 27.4975 42.7952Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.641 27.5005C19.641 23.1611 23.1585 19.6433 27.4975 19.6433C31.8365 19.6433 35.3539 23.1611 35.3539 27.5005C35.3539 31.8398 31.8365 35.3576 27.4975 35.3576C23.1585 35.3576 19.641 31.8398 19.641 27.5005Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2143 27.5005C27.2143 27.6569 27.3411 27.7837 27.4975 27.7837C27.6539 27.7837 27.7806 27.6569 27.7806 27.5005C27.7806 27.344 27.6539 27.2173 27.4975 27.2173C27.3411 27.2173 27.2143 27.344 27.2143 27.5005ZM27.4975 19.6433C23.1585 19.6433 19.641 23.1611 19.641 27.5005C19.641 31.8398 23.1585 35.3576 27.4975 35.3576C31.8365 35.3576 35.3539 31.8398 35.3539 27.5005C35.3539 23.1611 31.8365 19.6433 27.4975 19.6433Z",
    fill: "#020845"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7861 25.1001C49.9443 26.4199 49.0272 27.6452 47.7377 27.8371L25.6833 31.118C24.3938 31.3098 23.2203 30.3955 23.0622 29.0758C22.904 27.756 23.8211 26.5307 25.1106 26.3388L47.165 23.0579C48.4544 22.8661 49.628 23.7804 49.7861 25.1001Z",
    fill: "#020845"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4385 20.1213L48.1784 20.9838L44.8057 24.585L49.7861 23.9727L50.4751 24.5274L54.4385 20.1213Z",
    fill: "#256BE4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55 29.7568L48.6865 29.8595L45.1596 27.2507L50.3206 26.2778L55 29.7568Z",
    fill: "#256BE4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.705 25.1211C50.8022 25.8573 50.2876 26.5367 49.5557 26.6386L25.9748 29.9219C25.2429 30.0238 24.5708 29.5097 24.4737 28.7735C24.3765 28.0373 24.8911 27.3579 25.623 27.256L49.2039 23.9727C49.9358 23.8707 50.6079 24.3849 50.705 25.1211Z",
    fill: "#256BE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreciselyEngineered);
export default __webpack_public_path__ + "static/media/precisely-engineered.5881dea70f9d710ab02a9d003d64276d.svg";
export { ForwardRef as ReactComponent };